import {request,setAuthInHeader} from "@/api/request";
import Vue from "vue"

const state = {
    countryList: [],
    languageList: [],
    cIdx: 30,
}

const getters = {
    getCountryList: state => state.countryList,
    getLanguageList: state => state.languageList,
    getCIdx: state => state.cIdx,
}

const mutations = {
    updateCountryList(state, obj) {
        state.countryList = obj.data;
    },
    updateLanguageList(state, obj) {
        state.languageList = obj.data;
    },
    updateCIdx(state, obj) {
        state.cIdx = obj.data;
    }
}

const actions = {
    setCountry({commit, rootState}, {}) {
        try {
            /*request.get('country', {ip: 0, c_is_use: 1}).then(res => {
                if(res.data.Data.Result.Info.type === 1) {
                    let countries = res.data.Data.Result.List;
                    let languageList = countries.filter(c => c.c_is_use === 1);
                    commit('updateCountryList', {data: countries})
                    commit('updateLanguageList', {data: languageList})
                    // let langName = localStorage.getItem('com.dgmonglab.flyhighlang');s: ""ㅜ
                }
            })*/
            let languageList = [
                {c_code:"KR", c_idx:1, c_is_use:1, c_lang:"한국어", c_lang_en:"Korean", c_lang_ko:"한국어", c_location:"KO", c_name_kr:"대한민국", c_name_us:"Korea, Republic Of", c_number:"82"},
                {c_code:"US", c_idx:30, c_is_use:1, c_lang:"English", c_lang_en:"English", c_lang_ko:"영어", c_location:"EN", c_name_kr:"미국", c_name_us:"United States", c_number:"1"},
                {c_code:"CN", c_idx:3, c_is_use:1, c_lang:"中國語", c_lang_en:"Chinese", c_lang_ko:"중국어", c_location:"ZH", c_name_kr:"중화인민공화국", c_name_us:"China", c_number:null},
            ]
            commit('updateLanguageList', {data: languageList})
        }catch (e) {
            console.log(e);
        }
    },
    setCIdx({commit, rootState}, {}) {
        let langName = Vue.$localStorage.get('lang');
        let languageIndex = state.languageList.findIndex(lang => lang.c_location.toLowerCase() === langName);
        if(languageIndex >= 0) {
            let c_idx = state.languageList[languageIndex].c_idx;
            commit('updateCIdx', {data: c_idx});
        }
    }
}

export default { namespaced: true, state, getters, mutations, actions }
